function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Registracny-Proces_1",
  transform: "translate(-1065.000000, -250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(318.000000, 226.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sucess",
  transform: "translate(747.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z",
  id: "outline-transparent",
  fill: "#09BA50",
  opacity: 0.200000003
}), /*#__PURE__*/React.createElement("g", {
  id: "check-circle-2",
  transform: "translate(8.000000, 8.000000)",
  stroke: "#09BA50",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "check-circle"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,7.68 L15,8.38095238 C14.9981009,11.7551892 12.8117205,14.7262575 9.62651431,15.6829722 C6.44130815,16.6396868 3.01604516,15.3541426 1.20821631,12.5234791 C-0.599612532,9.69281566 -0.359352416,5.99134398 1.79870565,3.42634068 C3.95676371,0.86133738 7.51853449,0.043828788 10.5525,1.41714286",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "15 2.28571429 7.5 9.91238095 5.25 7.62666667"
})))))));

var SvgSuccessCheck = function SvgSuccessCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-check.3f335bc5.svg";
export { ForwardRef as ReactComponent };